import React from 'react';
import { HeroSection } from '../../proposal/sections/dach/HeroSection';
import { DACH_DATA } from '../../proposal/data/dachData';
import { DraggableElement } from '../../DraggableElement';

/**
 * Page 1 (A4) – Deckblatt.
 * Composer: zieht die HeroSection aus dem Komponentensystem.
 */
export const CoverPageDach = ({ editMode, textEditMode = false, layoutEditLevel, proposalData = DACH_DATA, textContent, onTextChange, showMarkers = true, selectedElements, elementPositions, onSelectElement, onPositionChange }) => {
  const dragProps = {
    editMode,
    selectedElements,
    elementPositions,
    onSelectElement,
    onPositionChange,
    dragAxis: 'y',
    showMarkers,
  };

  return (
    <div className="a4-page" data-testid="cover-page-dach" style={{ background: '#0E1E3C', overflow: 'hidden' }}>
      <DraggableElement
        id="S1-Deckblatt"
        {...dragProps}
        initialStyle={{ width: '100%', height: '100%' }}
      >
        <HeroSection
          kundenname={proposalData.kundenname}
          kundenadresse={proposalData.kundenadresse}
          angebotsnummer={proposalData.angebotsnummer}
          kundennummer={proposalData.kundennummer}
          datum={proposalData.datum}
          gueltigBis={proposalData.gueltig_bis}
          content={textContent?.cover || proposalData.text?.cover || DACH_DATA.text?.cover}
          onTextChange={onTextChange}
          editMode={textEditMode}
          layoutEditLevel={layoutEditLevel}
          dragProps={dragProps}
        />
      </DraggableElement>
    </div>
  );
};
